var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"completedCounter",attrs:{"id":_vm.id},domProps:{"innerHTML":_vm._s(_vm.displayValue)}})}
var staticRenderFns = []

export { render, staticRenderFns }